import Harshal from "../utils/image/harshal-mahajan.png"
import Sejal from "../utils/image/sejal-nehete.jpeg"
import Ratna from "../utils/image/ratna-kasar.png"
import Swati from "../utils/image/swati-sonawane.png"
import Vatsalya from "../utils/image/vatsalya-bendale.jpeg"


export const services = [
  {
    title: "Custom Software Development",
    description:
      "Tailored software architecture and engineering built around your business goals.",
    timeline: "4-12 weeks",
    outcome: "Scalable product foundation",
    features: [
      "Business workflow automation",
      "Custom dashboards and portals",
      "API design and third-party integrations",
    ],
  },
  {
    title: "Web Application Development",
    description:
      "Fast, secure, and scalable web experiences with modern engineering practices.",
    timeline: "3-10 weeks",
    outcome: "High-performance web platform",
    features: [
      "Responsive frontend development",
      "Secure backend systems",
      "Performance tuning and deployment",
    ],
  },
  {
    title: "Mobile App Development",
    description:
      "Cross-platform mobile apps designed for performance and seamless user journeys.",
    timeline: "5-14 weeks",
    outcome: "Launch-ready mobile product",
    features: [
      "Android and iOS app development",
      "Push notifications and analytics",
      "App store release support",
    ],
  },
  {
    title: "UI/UX Design",
    description:
      "Human-centered interfaces that blend usability, speed, and visual sophistication.",
    timeline: "2-6 weeks",
    outcome: "Polished product experience",
    features: [
      "User journey mapping",
      "Wireframes and interactive prototypes",
      "Design systems and UI screens",
    ],
  },
];

export const serviceProcess = [
  {
    step: "01",
    title: "Discover",
    text: "We understand goals, users, scope, technical risks, and the outcomes your business needs.",
  },
  {
    step: "02",
    title: "Design",
    text: "We map user flows, system architecture, feature priorities, and delivery milestones.",
  },
  {
    step: "03",
    title: "Develop",
    text: "Our team builds in focused sprints with reviews, QA, and transparent progress updates.",
  },
  {
    step: "04",
    title: "Launch",
    text: "We deploy, monitor, optimize, and support the product as real users start using it.",
  },
];

export const serviceTechnologies = [
  "React",
  "Node.js",
  "Next.js",
  "React Native",
  "Firebase",
  "AWS",
  "MongoDB",
  "PostgreSQL",
];

export const companyHighlights = [
  {
    title: "Product-Led Engineering",
    text: "We connect business goals, user needs, and technical execution before writing code.",
  },
  {
    title: "Reliable Delivery",
    text: "Every project moves through clear planning, weekly progress updates, QA, and launch support.",
  },
  {
    title: "Scalable Technology",
    text: "Our team builds platforms that can handle growth, integrations, automation, and future features.",
  },
];

export const featuredProjects = [
  {
    title: "SaaS Operations Platform",
    type: "Web App",
    result: "Reduced manual workflows by 45%",
  },
  {
    title: "Customer Booking App",
    type: "Mobile App",
    result: "Improved repeat bookings by 32%",
  },
  {
    title: "Analytics Dashboard",
    type: "Data Product",
    result: "Delivered real-time business visibility",
  },
];

export const products = [
  {
    title: "School Management Project",
    category: "Education Platform",
    image:
      "https://images.pexels.com/photos/5212345/pexels-photo-5212345.jpeg?auto=compress&cs=tinysrgb&w=900",
    description:
      "A complete digital school system for admissions, students, teachers, attendance, exams, fees, and parent communication.",
    features: [
      "Student, teacher, and class management",
      "Attendance, timetable, exam, and result modules",
      "Fee tracking with parent updates and admin reports",
    ],
    impact: "Helps schools reduce paperwork and manage daily operations from one dashboard.",
  },
  {
    title: "Book Management Project",
    category: "Library & Inventory System",
    image:
      "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=900&q=80",
    description:
      "A smart book and library management product for cataloging books, managing borrowers, tracking stock, and monitoring issue-return activity.",
    features: [
      "Book catalog, author, category, and shelf tracking",
      "Member records, issue-return history, and due dates",
      "Search, availability, fine calculation, and stock reports",
    ],
    impact: "Makes library operations faster, organized, and easier for staff and readers.",
  },
  {
    title: "Garage Management Project",
    category: "Automotive Service System",
    image:
      "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=900&q=80",
    description:
      "A garage workflow system for vehicle service bookings, job cards, mechanics, spare parts, billing, and customer updates.",
    features: [
      "Vehicle records, service history, and job card tracking",
      "Mechanic assignment, spare parts inventory, and invoices",
      "Customer reminders, service status, and payment reports",
    ],
    impact: "Keeps repair shops organized from booking to final delivery and billing.",
  },
];

export const growthDetails = [
  { label: "Product Launches", value: "120+", text: "Delivered across web, mobile, and cloud" },
  { label: "Client Retention", value: "92%", text: "Long-term partnerships built on trust" },
  { label: "Faster Delivery", value: "35%", text: "Reusable systems speed up new releases" },
];

export const testimonials = [
  {
    quote:
      "BeeVerge understood our product quickly and delivered a clean platform that our team could actually scale.",
    name: "Karan Desai",
    company: "Founder, RetailGrid",
  },
  {
    quote:
      "Their design and engineering team brought structure, speed, and clarity to a very complex app build.",
    name: "Meera Kapoor",
    company: "COO, HealthSync",
  },
];

export const contactDetails = [
  {
    label: "Email",
    value: "beeverge27@gmail.com",
    text: "Send project details, partnership ideas, or support requests.",
  },
  {
    label: "Phone",
    value: "+91 897******3",
    text: "Talk with our team about scope, timeline, and next steps.",
  },
  {
    label: "Location",
    value: "India",
    text: "Serving startups, agencies, and enterprises worldwide.",
  },
];

export const contactHighlights = [
  "Project consultation within 24 hours",
  "Clear scope, budget, and milestone planning",
  "Support for web, mobile, SaaS, and automation ideas",
];

export const projectTypes = [
  "Custom Software",
  "Web Application",
  "Mobile App",
  "UI/UX Design",
  "Product Consultation",
];

export const careerOpenings = [
  {
    title: "Frontend Developer",
    type: "Full Time",
    location: "Remote / India",
    experience: "1-3 years",
    summary:
      "Build polished React interfaces, reusable components, dashboards, and product experiences for client projects.",
    skills: ["React", "Tailwind CSS", "Framer Motion"],
  },
  {
    title: "Backend Developer",
    type: "Full Time",
    location: "Hybrid",
    experience: "2-4 years",
    summary:
      "Design secure APIs, database models, integrations, and cloud-ready services for scalable applications.",
    skills: ["Node.js", "MongoDB", "REST APIs"],
  },
  {
    title: "UI/UX Designer",
    type: "Internship",
    location: "Remote",
    experience: "Freshers welcome",
    summary:
      "Create user flows, wireframes, prototypes, and visual systems for web and mobile products.",
    skills: ["Figma", "Prototyping", "Design Systems"],
  },
];

export const careerBenefits = [
  "Work on real startup and enterprise products",
  "Flexible culture with learning-focused mentorship",
  "Clear ownership, feedback, and growth opportunities",
  "Modern tools, practical processes, and supportive teamwork",
];

export const blogPosts = [
  {
    title: "How To Plan A Successful Software Project",
    category: "Product Strategy",
    date: "Apr 18, 2026",
    image:
      "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=900&q=80",
    excerpt:
      "A practical guide to defining scope, features, timelines, and success metrics before development starts.",
    readTime: "5 min read",
  },
  {
    title: "Why Businesses Need Custom Dashboards",
    category: "Automation",
    date: "Apr 10, 2026",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
    excerpt:
      "Dashboards turn scattered operations into clear decisions, faster reporting, and stronger team visibility.",
    readTime: "4 min read",
  },
  {
    title: "Mobile App Features Customers Actually Use",
    category: "Mobile Apps",
    date: "Mar 28, 2026",
    image:
      "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=900&q=80",
    excerpt:
      "The best mobile products focus on speed, clarity, reminders, profiles, payments, and meaningful engagement.",
    readTime: "6 min read",
  },
];

export const counters = [
  { label: "Projects", value: 120, suffix: "+" },
  { label: "Clients", value: 80, suffix: "+" },
  { label: "Experience", value: 9, suffix: " yrs" },
];

export const timeline = [
  {
    title: "Mission",
    text: "Enable companies to scale through reliable digital products, clean engineering, and practical innovation.",
  },
  {
    title: "Vision",
    text: "Build future-ready software ecosystems where speed, quality, and security work together.",
  },
  {
    title: "Approach",
    text: "Collaborative delivery model with agile execution, transparent communication, and measurable outcomes.",
  },
];


export const founder = {
  name: "Harshal Motiram Mahajan",
  role: "Founder & CEO",
  image: Harshal,
  summary:
    "Harshal Motiram Mahajan is the Founder and CEO of BeeVerge. He founded the company to help ambitious businesses turn raw ideas into dependable digital products. His focus is simple: understand the business problem deeply, design the right technical path, and deliver software that can grow with the company.",
  details: [
    "Product strategy, cloud architecture, and delivery leadership",
    "Hands-on guidance from discovery through launch",
    "Strong focus on performance, security, and long-term maintainability",
  ],
};

export const teamMembers = [
  {
    name: "Sejal Nehete",
    role: "Lead Full-Stack Engineer",
    image: Sejal,
    detail: "Builds scalable web platforms, APIs, and deployment pipelines.",
  },
  {
    name: "Ratna Kasar",
    role: "UI/UX Designer",
    image: Ratna,
    detail: "Shapes clear product flows and polished interface systems.",
  },
  {
    name: "Swati Sonawane",
    role: "Mobile App Developer",
    image: Swati,
    detail: "Creates fast cross-platform mobile experiences for modern teams.",
  },
  {
    name: "Vatsalya Bendale",
    role: "Project Manager",
    image: Vatsalya,
    detail: "Keeps delivery focused, transparent, and aligned with business goals.",
  },
];
